import { ControlledTextField } from '@if/mui'
import { Grid, Stack, Typography } from '@mui/material'
import { Control, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { NewLoanDtoSchemaType } from './loan-form-schema'

interface Props<TFieldValues extends FieldValues> {
  control: Control<NewLoanDtoSchemaType, TFieldValues>
}

const PpaConfigInputRow = <TFieldValues extends FieldValues = FieldValues>({ control }: Props<TFieldValues>) => {
  const { t } = useTranslation()

  return (
    <Grid marginTop={2} size={12}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{t('loan.ppaConfig.title')}</Typography>
          </Stack>
        </Grid>
        <Grid size={6}>
          <ControlledTextField
            control={control}
            name="loanData.ppaConfig.bankName"
            label={t('loan.ppaConfig.bankName')}
          />
        </Grid>

        <Grid size={6}>
          <ControlledTextField
            control={control}
            name="loanData.ppaConfig.institutionNumber"
            type="number"
            label={t('loan.ppaConfig.institutionNumber')}
          />
        </Grid>

        <Grid size={6}>
          <ControlledTextField
            control={control}
            name="loanData.ppaConfig.transitNumber"
            type="number"
            label={t('loan.ppaConfig.transitNumber')}
          />
        </Grid>

        <Grid size={6}>
          <ControlledTextField
            control={control}
            name="loanData.ppaConfig.accountNumber"
            type="number"
            label={t('loan.ppaConfig.accountNumber')}
          />
        </Grid>

        <Grid size={6}>
          <ControlledTextField
            control={control}
            name="loanData.ppaConfig.accountHolderName"
            label={t('loan.ppaConfig.accountHolderName')}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PpaConfigInputRow
